// This should probably move into the groups api on the groups search as an include
export const getInitials = str => {
  if (!str) return null

  const names = str.trim().replace(/\s+/g, ' ').split(' ')
  if (names.length === 0) return null

  // Ignore the last name if it's a suffix like Jr., Sr., etc.
  const suffixes = ['Jr', 'Sr', 'II', 'III', 'IV']
  const filteredNames = names.filter((name, i) =>
    i < 2 || (i === 2 && !suffixes.includes(name.replace(/\./g, '')))
  )

  const initials = filteredNames.slice(0, 2).map(name => name[0].toUpperCase())

  return initials.join('')
}
